module.exports = __webpack_public_path__ + "img/solutions_4.6f4941f5.png";